import React, { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { souborUrl } from "../lib/api";

// Prohlížeč fotek přes celou obrazovku. Technik potřebuje ověřit, co vyfotil,
// dřív než zápis odešle — z náhledu 100×100 to nepozná.
export default function FotoLightbox({ fotky, index, onClose, onIndex }) {
  const posun = useCallback((delta) => {
    if (!fotky.length) return;
    onIndex((index + delta + fotky.length) % fotky.length);
  }, [fotky.length, index, onIndex]);

  useEffect(() => {
    const key = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") posun(1);
      if (e.key === "ArrowLeft") posun(-1);
    };
    document.addEventListener("keydown", key);
    return () => document.removeEventListener("keydown", key);
  }, [onClose, posun]);

  const f = fotky[index];
  if (!f) return null;
  return (
    <div className="fixed inset-0 z-[80] bg-black/90 flex items-center justify-center"
      onClick={onClose} data-testid="foto-lightbox">
      <button onClick={onClose} aria-label="Zavřít"
        className="absolute top-4 right-4 h-11 w-11 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-white/20"
        data-testid="foto-lightbox-close"><X size={20} /></button>

      {fotky.length > 1 && (
        <>
          <button onClick={(e) => { e.stopPropagation(); posun(-1); }} aria-label="Předchozí"
            className="absolute left-3 h-11 w-11 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-white/20"
            data-testid="foto-lightbox-prev"><ChevronLeft size={22} /></button>
          <button onClick={(e) => { e.stopPropagation(); posun(1); }} aria-label="Další"
            className="absolute right-3 h-11 w-11 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-white/20"
            data-testid="foto-lightbox-next"><ChevronRight size={22} /></button>
          <span className="absolute bottom-5 amount text-[12px] text-white/70">{index + 1} / {fotky.length}</span>
        </>
      )}

      <img src={souborUrl(f.url)} alt="" onClick={(e) => e.stopPropagation()}
        className="max-h-[88vh] max-w-[94vw] object-contain rounded-icon" />
    </div>
  );
}
